import Immutable   from 'immutable';
import { HasMany } from './associations';

export default class AssociationFinder {
  constructor(associations) {
    this.associations = associations;
  }

  belongingEntitiesOf(entity) {
    let handled  = new Immutable.Set([entity]);
    let entities = this.directBelongingEntitiesOf(entity);

    while (entities.subtract(handled).size) {
      handled  = handled.union(entities);
      entities = entities.map(entity => this.directBelongingEntitiesOf(entity)).flatten();
    }

    return handled.union(entities);
  }

  directBelongingEntitiesOf(entity) {
    const associations = this.associations.forModel(entity.constructor).ofType(HasMany);
    const entitySets   = associations.map(assoc => entity.associations[assoc.name].entitySet());

    return entitySets.flatten();
  }
}
